module.exports = __webpack_public_path__ + "static/media/ilkka-suhonen.b48a097c.jpg";